<template>
	<div class="input__wrapper">
		<label  :class="{ 'focused': focused }">
			<span class="input-label" :id="data.labelId">{{ data.label }}</span>
			<div class="input-tags">
				<div class="tags">
					<div class="tags__box">
						<span class="asInput" v-for="(tag, index) in tags" @keyup.delete="backspaceDeleteTag(index)" :class="{ deleting: confirmWaiting && position==index + 1 }" :key="tag.index">
							<span>{{tag}}</span>
							<span class="delete-item" @click="deleteTag(index)">
								<SvgIcon class="delete-tag-icon" iconName="ico-close-sm"/>
							</span>
						</span>
						<input 
							:placeholder="data.placeholder" 
							v-model="newTag"
							@blur="isBlure"
							@keydown.enter.prevent="addItem($event)"
							:id="data.inputId"
							@keydown.delete="backspaceDelete()"
							ref="tagInput"
							/>
					</div>
				</div>
				<span class="delete-all-item" ref="deleteAll" @click="removeAll">
					<SvgIcon class="delete-tag-icon delete-tag-icon--big" iconName="ico-close-icon"/>
				</span>
			</div>
		</label>
	</div>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},

	data () {
		return {
			newTag: '',
			confirmWaiting: false,
			position: 1,
			tags: [],
			focused: false,
			index: ''
		};
	},
	watch: {
		tags() {
			this.$emit('input', this.tags);
			if (this.tags.length > 0) {
				this.$refs.deleteAll.classList.add('showDeleteIcon');
				this.$refs.tagInput.classList.add('hidePlaceholder');
			}
		}
	},
	components: {
		SvgIcon
	},
	methods: {
		backspaceDeleteTag(index) {
			this.tags.splice(index, 1);
		},
		backspaceDelete(index) {
			if (this.newTag === '') {
				this.tags.splice(index, 1);
			}
			if (this.tags.length <= 0) {
				this.$refs.deleteAll.classList.remove('showDeleteIcon');
			}
		},
		deleteTag(index) {
			this.tags.splice(index, 1);
			if (this.tags.length <= 0) {
				this.$refs.deleteAll.classList.remove('showDeleteIcon');
			}
		},
		addItem(e) {
			const val = e.target.value;
			if (val !== '') {
				const arr = val.split(',');
				if (this.tags.length > 0) {
					const newArr = this.tags.concat(arr);
					this.tags = newArr;
				} else {
					this.tags = arr;
				}
				this.newTag = '';
				this.$refs.deleteAll.classList.add('showDeleteIcon');
			}
			this.focused = true;
		},
		setValue(value) {
			this.tags = value;
		},
		isBlure() {
			this.$refs.tagInput.classList.remove('hidePlaceholder');
			this.focused = false;
		},
		removeAll() {
			this.tags.splice(0);
			this.$refs.deleteAll.classList.remove('showDeleteIcon');
			this.focused = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.tags {
	display: flex;
	flex-direction: row;
	box-shadow: none;
	border: 1px solid $grey-light;
	border-radius: 8px;
	padding: 11px 27px 11px 19px;
	line-height: 1.2;
	width: 100%;
	font-size: 14px;
	width: 100%;
	font-family: $font-main;
	line-height: 1.2;
	color: $slate-gray;
	min-height: 48px;
	transition: $dur $ease;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;

	@include mq($sm) {
		font-size: 16px;
	}
	
	.asInput {
		line-height: 1;
		width: auto;
		background-color: $athens-gray;
		border: 1px solid transparent;
		border-radius: 8px;
		padding: 2px 5px;
		margin-right: 10px;
		display: flex;
		color: $fiord;
		align-items: center;
		font-family: $font-main;
	}
	
	input {
		margin: 0;
		opacity: 1;
		transition: all .3s ease-in-out;
		border: none;
		height: auto;
		padding: 0;
		font-family: $font-main;

		@include mq($sm) {
			font-size: 16px;
		}
	}
}

.tags__box {
	display: flex;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	width: 100%;

	input {
		font-size: 14px;

		@include mq($sm) {
			font-size: 16px;
		}
	}
}

input::-webkit-input-placeholder { /* Chrome/Opera/Safari */
	color: #bdbdbd;
}
input::-moz-placeholder { /* Firefox 19+ */
	color: #bdbdbd;
}
input:-ms-input-placeholder { /* IE 10+ */
	color: #bdbdbd;
}
input:-moz-placeholder { /* Firefox 18- */
	color: #bdbdbd;
}

.focused {
	.tags {
		border: 1px solid $dodger-blue;
	}

}

input::-webkit-input-placeholder {
	opacity: 1;
	width: 100%;
	transition: $dur $ease;
}
input:-moz-placeholder {
	opacity: 1;
	width: 100%;
	transition: $dur $ease;
}
input::-moz-placeholder {
	opacity: 1;
	width: 100%;
	transition: $dur $ease;
}
input:-ms-input-placeholder {
	opacity: 1;
	width: 100%;
	transition: $dur $ease;
}

.input-tags {
	position: relative;
	border: 1px solid $white-lilac;
	background-color: $white-lilac;
	border-radius: 14px;
}

.delete-item {
	margin-left: 5px;
	padding: 2px 0 2px 4px;
	position: relative;

	&::before {
		content: '';
		background-color: $white;
		width: 1px;
		height: 95%;
		left: -2px;
		top: 50%;
		transform: translateY(-50%);
		position: absolute;
		z-index: 3;
	}
}

.delete-tag-icon {
	font-size: 7px;
	color: $fiord;
}

.delete-all-item {
	position: absolute;
    right: 9px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
	z-index: 5;
	opacity: 0;
	transition: $dur $ease;
	color: $fiord;

	&.showDeleteIcon {
		opacity: 1;
	}

	.delete-tag-icon {
		font-size: 13px;
	}

	@include hover {
		color: $mine-shaft;
	}
}
</style>
